import styles from './edit-catalog-dialog.module.scss';
import { useCourseGetRequestHook } from '../../../requestUtils';
import BaseCatalogDialog from '../../../base-catalog-dialog/base-catalog-dialog';
import { ICatalogItem } from '../../../_models/catalog-item';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EditCatalogDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  catalogId: string
}
export function EditCatalogDialog(props: EditCatalogDialogProps) {
  const { data: catalogItem }: { data: ICatalogItem } = useCourseGetRequestHook(`catalog/getItem/${props.catalogId}`, undefined);
  const { t } = useTranslation();

  return catalogItem && <BaseCatalogDialog
    onClose={props.onClose}
    open={props.open}
    refreshData={props.refreshData}
    catalogItem={catalogItem}
    handleOkText={t("standard.updateCourse")}
    headerText={t("standard.changeCourse")}
  />
}

export default EditCatalogDialog;
